<script setup lang="ts">
import type { ImageSet, Action } from '../types'
import { cn } from '@/lib/utils'
import { spacingClasses } from '../utils/classes'
import ACImage from './ACImage.vue'

const props = defineProps<{
  element: ImageSet
  onAction?: (action: Action, inputs: Record<string, string>) => void
}>()
</script>

<template>
  <div :class="cn('flex flex-wrap gap-2', spacingClasses[props.element.spacing ?? 'default'])">
    <ACImage
      v-for="(image, index) in props.element.images"
      :key="index"
      :element="image"
      :on-action="props.onAction"
      :size-override="props.element.imageSize"
    />
  </div>
</template>
